console.log(
    'Curios how its done? We are using paper.js and gatsby.js.',
    'Some behind the scenes: http://tiep.com/.',
    'Check out the source code https://tiep.com'
);
